module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items != null) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "problem-manage"
    }
  }, [_c('div', {
    staticClass: "col-12 grid"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.add_problem_id),
      expression: "add_problem_id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ID"
    },
    domProps: {
      "value": (_vm.add_problem_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.add_problem_id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.add_problem_git),
      expression: "add_problem_git"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Git Repository"
    },
    domProps: {
      "value": (_vm.add_problem_git)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.add_problem_git = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('button', {
    on: {
      "click": _vm.onAddProblem
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('table', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', {
      staticClass: "grid"
    }, [_c('td', {
      staticClass: "col-1"
    }, [_vm._v(_vm._s(item.problem.uid))]), _vm._v(" "), _c('td', {
      staticClass: "col-4"
    }, [_c('router-link', {
      attrs: {
        "to": ("/problem/" + (item.problem.uid) + "/")
      }
    }, [_vm._v(_vm._s(item.problem.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": item.problem.revision
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.git),
        expression: "item.git"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Git Repository"
      },
      domProps: {
        "value": (item.git)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.git = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-1"
    }, [_c('div', {
      staticClass: "grid grid-noGutter"
    }, [_c('div', {
      staticClass: "col",
      attrs: {
        "title": "Rejudge"
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onRejudgeProblem(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Update"
      }
    }, [_c('i', {
      staticClass: "fa fa-upload btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onUpdateProblem(item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col",
      attrs: {
        "title": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o btn",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.onRemoveProblem(item)
        }
      }
    })])])])])
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "grid"
  }, [_c('th', {
    staticClass: "col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "col-4"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Revision")]), _vm._v(" "), _c('th', {
    staticClass: "col"
  }, [_vm._v("Git Repository")]), _vm._v(" "), _c('th', {
    staticClass: "col-1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50ad2af6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ProblemManage.vue
// module id = 582
// module chunks = 0